function SpacePirates() {

    return (<div>
        This is one of the miscellaneous challenges from the HTB Uni CTF Qualifiers 2021.
    </div>);
}

export default SpacePirates;